export const numberCompareAscFn = (a: number, b: number): number => b - a;

export const numberCompareDescFn = (a: number, b: number): number => a - b;
